module.exports = {"371425001":"晏城街道","371425002":"晏北街道","371425101":"表白寺镇","371425102":"焦庙镇","371425103":"赵官镇","371425104":"祝阿镇","371425105":"仁里集镇","371425106":"潘店镇","371425107":"胡官屯镇","371425108":"宣章屯镇","371425109":"马集镇","371425110":"华店镇","371425111":"刘桥镇","371425201":"安头乡","371425204":"大黄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371425.json
// module id = 1477
// module chunks = 0